<!-- 兑换记录 -->
<template>
  <div class="content">
      <div class="bodycontent">
          <div class="cont">
            <el-table
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="merch.merch_name"
                label="商家名称"
                width="180">
              </el-table-column>
              <el-table-column
                label="报名时间">
                <template slot-scope="scope">
                  {{ scope.row.get_start_time}} - {{ scope.row.get_end_time}}
                </template>
              </el-table-column>
              <el-table-column
                prop="stock"
                label="报名状态">
                </el-table-column>
              <el-table-column
                label="报名商品">
                <template slot-scope="scope">
                  <el-button size="mini" v-if="scope.row.status == '1'" type="success">审核通过</el-button>
                  <el-button size="mini" v-if="scope.row.status == '2'" type="danger">审核未通过</el-button>
                </template>
                </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handle(1,scope.row.id)" v-if= "scope.row.status== '0' || scope.row.status == '2' ">同意</el-button>
                  <el-button size="mini" @click="handle(2,scope.row.id)" v-if= "scope.row.status== '0' || scope.row.status == '1' ">拒绝</el-button>
                </template>
                  
              </el-table-column>
            </el-table>
            
          </div>
      </div>
  </div>
</template>

<script>
import { applicatList, applicatAudit } from "@/api/active";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"])
  },
  data () {
    return {
      data: "",
      screenInput: "",
      
      tableData: [],
    };
  },

  components: {},
  mounted(){
    this.getList();
  },
  methods: {
    // 筛选
    screen(){
      console.log("screenInput", this.screenInput);
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: this.screenInput,
        store_id: 0, //
      }
      applicatList(data).then(res => {
        console.log("列表", res);
        this.tableData = res.data.result;
      })
    },
    getList(){
      let data = {
        token: this.token,
        app_id: this.app_id,
        // store_id: 0, //
        set_status: 0,
      }
      applicatList(data).then(res => {
        console.log("列表", res);
        this.tableData = res.data.result;
      })
    },
    // 操作 type 1 编辑 0 删除 index =>对应商品id
    handle(type, index) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
        id: index,
        status: type
      }
      var message = "";
      if(type == '1'){
        message = "确定同意通过"
      }else{
        message = "确定拒绝通过"
      }
      this.$confirm( message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        applicatAudit(data).then( res => {
          console.log("shanchu ", res)
          if(res.code == 200){
            this.$message.success(res.msg);
            this.reload();
          }else{
            this.$message("操作失败");
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });          
      });
    }
  }
}
</script>
<style lang= 'scss' scoped>
@import "./public/style/_interfacePublic";
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content{
  width: 100%;
  .bodycontent {
    height: 100%;
    overflow: auto;
    .top {
      height: 80px;
      padding: 20px 0;
    }
    .cont{
      height: calc(100% - 80px);
      .table{
        border: 1px solid #eeeeee;
        .title{
          height: 60px;
          line-height: 60px;
          background: #f5f7fa;
        }
        .list{
          padding: 20px 0 20px;
          .box{
            border: 1px solid #f1f1f1;
            .bianhao{
              height: 40px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: #f5f7fa;
            }

          }
        }
      }
    }
  }
}
</style>